import { GridCellParams } from "@mui/x-data-grid";
import { UseRecordsOptions } from "../../api/useRecords";
import { UpdateStatusTransactionShortcut } from "./UpdateStatusTransactionShortcut";
import { TotalAmountOfAssociatedOrders } from "./OrdersAssociatedRecords/TotalAmountOfAssociatedOrders";
import { AllocationSummary } from "./AllocationSummary";

export const bankTransactionsOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "category",
                sort: "parent_transaction_category.name",
                enabled: true,
                relatedWith: "company",
                dependency: {
                    field: "company",
                    placeHolder: "Selecione uma empresa",
                },
                createFilter: (params: any) => filterCategories(params),
            },
            {
                field: "vendor",
                sort: "name",
                enabled: true,
            },
            {
                field: "company",
                sort: "name",
                enabled: true,
            },
            {
                field: "bank",
                sort: "name",
                enabled: true,
            },
            {
                field: "ai_rationale",
                charactersLimit: 5000,
            },
            {
                field: "documents",
                fileFolder: "606f4f2c-7d63-41c2-8027-d1b5b763e5f6",
                instanceToUse: "finance",
            },
        ],
    },
    dataGridOptions: {
        quickSearchToolBar: {
            active: true,
            inputLabel: "Pesquise por descrição ou valor...",
            fieldsToSearch: ["description", "amount"],
        },
        extraColumns: {
            beggining: [
                {
                    field: "status",
                    headerName: "Estado",
                    width: 75,
                    renderCell: (params: GridCellParams) => {
                        return <UpdateStatusTransactionShortcut id={params.row.id} status={params.row.status} />;
                    },
                },
            ],
            end: [
                {
                    field: "allocation",
                    headerName: "Alocação",
                    width: 110,
                    renderCell: (params: GridCellParams) => {
                        return <AllocationSummary operationalCenters={params.row.operational_centers} />;
                    },
                },
                {
                    field: "orders_total",
                    headerName: "Total de compras associadas",
                    width: 75,
                    renderCell: (params: GridCellParams) => {
                        const row = params.row;
                        const category = row.category;
                        if (!category) return null;
                        const categoriesToConsider = [91, 92, 93, 117, 124];
                        if (!categoriesToConsider.includes(category.id)) return null;
                        return <TotalAmountOfAssociatedOrders bankTransaction={row} type="list" />;
                    },
                },
            ],
        },
    },
    extraOptions: {
        sort: "-transaction_date",
    },
} as unknown as UseRecordsOptions;

const filterCategories = (params: any) => {
    var filter = {};

    if (!params || !params.id) return {};
    filter = {
        _and: [
            {
                companies: {
                    company_id: {
                        id: {
                            _eq: params.id,
                        },
                    },
                },
            },
        ],
    } as any;

    return filter;
};
